// extracted by mini-css-extract-plugin
export default {"heading":"BizKimiz_heading__8rjEx","imgSpan":"BizKimiz_imgSpan__qAx8n","bagciImg":"BizKimiz_bagciImg__FO9y8","linkedinImg":"BizKimiz_linkedinImg__4qzd8"};